@if (mobileData) {
  <rk-page-title [title]="'SCHEDULE.PROGRAMS.NEW_PROGRAM' | translate"></rk-page-title>
  <ng-container *ngTemplateOutlet="content"></ng-container>
  <rk-footer-actions
    (submitted)="submit()"
    (cancelled)="hideModalOrIntro()"
    [disabledSubmit]="
      !createProgramForm || !createProgramForm.get('name').valid || (isSaving$ | async)
    "
    [forceLeft]="true"
  ></rk-footer-actions>
  <ng-container *ngTemplateOutlet="introExtro"></ng-container>
} @else {
  <rk-sidenav-action-wrapper
    [title]="'SCHEDULE.PROGRAMS.NEW_PROGRAM' | translate"
    (submitted)="submit()"
    (cancelled)="cancel()"
    [disabledSubmit]="
      !createProgramForm || !createProgramForm.get('name').valid || (isSaving$ | async)
    "
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </rk-sidenav-action-wrapper>
}

<ng-template #content>
  <form
    *ngIf="createProgramForm"
    (ngSubmit)="submit()"
    [formGroup]="createProgramForm"
    novalidate
  >
    <div class="form-fields px-0 md:px-6 md:bg-white">
      <div>
        <rk-form-field
          [label]="'SCHEDULE.PROGRAMS.NAME' | translate"
          [hideCharLimit]="true"
        >
          <input type="text" rkInput formControlName="name" maxlength="150" required />
          <rk-form-error
            *ngIf="createProgramFormErrors.name.required"
            [errorMessage]="'SCHEDULE.PROGRAMS.TITLE_REQUIRED' | translate"
          ></rk-form-error>
        </rk-form-field>
        <rk-form-field [label]="'SCHEDULE.PROGRAMS.COLOR' | translate">
          <rk-input-color-picker
            [showWhite]="false"
            formControlName="color"
          ></rk-input-color-picker>
        </rk-form-field>
      </div>
    </div>
    <div class="intro-extro px-0 md:px-6">
      <rk-form-field
        label="Intro"
        [hintQuestionMark]="'SCHEDULE.PROGRAMS.HINT_INTRO' | translate"
      >
        <rk-track-input-with-suggestions
          [currentValue]="createProgramForm.value['intro']"
          [placeholder]="'MEDIA.SEARCH_BAR.PLACEHOLDER' | translate"
          [schedulerSearch]="true"
          (submitted)="setIntro($event)"
          (blurred)="setIntro(null)"
          (click)="this.mobileData ? openTrackSelector($event, 'intro') : null"
        ></rk-track-input-with-suggestions>
      </rk-form-field>
      <rk-form-field
        label="Extro"
        [hintQuestionMark]="'SCHEDULE.PROGRAMS.HINT_EXTRO' | translate"
      >
        <rk-track-input-with-suggestions
          [currentValue]="createProgramForm.value['extro']"
          [placeholder]="'MEDIA.SEARCH_BAR.PLACEHOLDER' | translate"
          [schedulerSearch]="true"
          (submitted)="setExtro($event)"
          (blurred)="setExtro(null)"
          (click)="this.mobileData ? openTrackSelector($event, 'extro') : null"
        ></rk-track-input-with-suggestions>
      </rk-form-field>
    </div>
  </form>
</ng-template>

<ng-template #introExtro>
  <div class="intro-extro-popover" [class.show]="$addingType()">
    <rk-intro-extro
      class="flex flex-col"
      [type]="$addingType()"
      (applyTrack)="applyTrack($event)"
    ></rk-intro-extro>
  </div>
</ng-template>
